import React, { useEffect, useRef, useState } from "react";
import config from '../../config';
import { headers } from "../../token";
import axios from "axios";
import html2pdf from 'html2pdf.js';
import { Link } from "react-router-dom";
import FormatDateString from "../dateFormat";
import AddComment from "./AddComment";
import ModifyComment from "./ModifyComment";
import vAdminformat from '../../adminFormat';
import Swal from "sweetalert2";
import STLViewer from "../Canvas/STLViewer";
import ColorBox from "../ColorBox";
import QRCode from "react-qr-code";
import { useReactToPrint } from 'react-to-print';
import validateError from "../../ValidateError";

import SimpleSTLViewerToImage from "../Canvas/SimpleStlViewsImage";
import UpdateOrder from "../orders/OrderUpdate";
import downloadOrderPDF from "./DownloadOrder";


const server_backend = config.API_URL;
const server_frontend = config.FrondEndURL;

const OrderQrView = ({ onRenderComplete, qr, trs }) => {

    const [Order, setOrder] = useState({
        Orders: []

    });
    const [trackingView, setTrackingView] = useState([]);
    const [isComment, setIsComment] = useState(false);
    const [isModifiyComment, setIsModifyComment] = useState(false);
    const [onCommentID, setOnCommentID] = useState(0);
    const [isUpdating, setIsUpdating] = useState(false);
    const [loading, setLoading] = useState(false);
    const [fileURL, setFileURL] = useState(null);
    const [statusOrder, setStatusOrder] = useState([]);
    const [showPrintableDiv, setShowPrintableDiv] = useState(false);
    const [currentDateTime, setCurrentDateTime] = useState('');
    const [currentComment, setCurrentComment] = useState("");
    const [currentPart, setCurrentPart] = useState([]);
    const [currentStatus, setCurrentStatus] = useState(null);
    const [Job, setJobs] = useState([])


    useEffect(() => {
        const getCurrentOrder = async () => {
            setLoading(true)
            try {
                const response = await axios.get(`${server_backend}/orders/view?trs=${trs}&qr=${qr}`, headers);
                console.log({ Here: response.data })
                if (response.data.RES_CODE === "00") {

                    const data = (response.data.RES_RESULT);
                    setCurrentDateTime(data.date_estimated);
                    setCurrentComment(data.comment);
                    setJobs(data.jobs)
                    setCurrentPart(data.parts)
                    setCurrentStatus(data.est_ID);
                    setFileURL(`${server_backend}/${data.jobs[0].files_path_file}`)
                    setOrder(data)

                }
            } catch (error) {
                console.log(error)
            } finally {
                setLoading(false)
                onRenderComplete && onRenderComplete()
            }
        }
        getCurrentOrder();
    }, []);

    useEffect(() => {
        const getStatusOrder = async () => {
            try {
                const response = await axios.get(`${server_backend}/system/transactions/status/Order`, headers);
                console.log({ Order: response.data });
                if (response.data.RES_CODE === "00") {
                    setStatusOrder(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error);
            }
        }
        getStatusOrder();
    }, []);

    /* useEffect(() => {
         const getTrackingData = async () => {
             try {
                 const response = await axios.get(`${server_backend}/Orders/tracking/list?id=${OrderID}`, headers);
                 if (response.data.RES_CODE === "00") {
 
                     const data = (response.data.RES_RESULT);
                     setTrackingView(data)
                 }
             } catch (error) {
                 console.log(error)
             }
         }
getTrackingData();
     }, []); */

    const getCurrentOrder = async () => {
        try {
            const response = await axios.get(`${server_backend}/orders/select?id=${Order.ord_ID}`, headers);
            //console.log(response.data)
            if (response.data.RES_CODE === "00") {
                //console.log(response.data.RES_RESULT);
                const data = (response.data.RES_RESULT);
                setCurrentDateTime(data.date_estimated);
                setCurrentComment(data.comment);
                setCurrentPart(data.parts)
                setCurrentStatus(data.est_ID);
                setOrder(data);
            }
        } catch (error) {
            console.log(error)
        } finally {
            onRenderComplete && onRenderComplete()
        }
    }

    const getTrackingData = async () => {
        try {
            const response = await axios.get(`${server_backend}/Orders/tracking/list?id=${Order.ord_ID}`, headers);
            if (response.data.RES_CODE === "00") {
                //console.log(response.data.RES_RESULT)
                const data = (response.data.RES_RESULT);
                setTrackingView(data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const downloadInvoice = () => {
        const element = document.getElementById('invoice-container');

        const options = {
            margin: 0,
            filename: 'invoice.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
        };

        html2pdf().set(options).from(element).save();
    };

    const printInvoice = () => {
        const printContents = document.getElementById('invoice-container').innerHTML;
        const originalContents = document.body.innerHTML;

        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;

    };


    const CloseAddCommentModal = () => {
        setIsComment(false)
    }

    const showModifyCommentModal = () => {
        setIsModifyComment(true)
    }

    const CloseModifyCommentModal = () => {
        setIsModifyComment(false)
    }

    const ShowModalUpdate = () => {
        setIsUpdating(true);
    }

    const CloseModalUpdate = () => {
        setIsUpdating(false);
    }

    const currentStep = statusOrder.find((status) => status.est_ID === Order.est_ID)?.est_ID || 0;
    const lastStep = Math.max(...statusOrder.map((step) => step.est_ID <= currentStep ? step.est_ID : -1));

    const statusDescriptions = {
        18: "In the process of printing the production folder.",
        19: "Preparing the model for building.",
        20: "The model is being invested for molding.",
        21: "Casting process is in progress.",
        22: "Production is complete and ready for review.",
    };



    const componentRef = useRef();


    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "Material Information",
        onAfterPrint: () => setShowPrintableDiv(false),

    });

    const handleClick = () => {

        setShowPrintableDiv(true);
        setTimeout(() => {
            handlePrint();
        }, 2000);

    };

    const [imageURL, setImageURL] = useState(null);

    useEffect(() => {
        const loadImage = async () => {
            try {
                const image = await SimpleSTLViewerToImage(fileURL);

                setImageURL(image);
            } catch (error) {
                console.error('Error:', error);
            }
        };

        if (fileURL) {
            loadImage();
        }
    }, [fileURL]);

    return (

        <div className="page-content" id="page-content">
            {/*start page title */}
            {isUpdating ? (
                <UpdateOrder CloseViewOrder={CloseModalUpdate} OrderID={Order.ord_ID} getOrders={getCurrentOrder} getCurrentOrder={getCurrentOrder} />

            ) : (
                <div>
                    <div className="row justify-content-center">
                        <div className="col-12 card">
                            <div className="card-header">
                                <div className="d-flex justify-content-between align-items-center mt-3 p-2">

                                    <div className="hstack text-nowrap gap-2">
                                       {/* <button
                                            type="button"
                                            className="btn btn-danger"

                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title="Go Back"
                                        >
                                            <i className="ri-arrow-go-back-line"></i>
</button> */}

                                        {/* <button
                                            type="button"
                                            className="btn btn-warning"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title="Edit"
                                            onClick={ShowModalUpdate}
                                        >
<i className="ri-pencil-fill align-bottom"></i>
                                        </button> */}
                                    </div>


                                    <div className="text-center flex-grow-1">
                                        <span className="fw-bold">Order Ref: <Link>{Order.ord_ID}</Link></span>
                                    </div>


                                    <div className="hstack text-nowrap gap-2">
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title="Print"
                                            onClick={handleClick}
                                        >
                                            <i className="ri-printer-line"></i>
                                        </button>

                                        <button
                                            type="button"
                                            className="btn btn-info"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title="Download"
                                            onClick={() => downloadOrderPDF(Order.ord_ID)}
                                        >
                                            <i className="ri-download-2-line"></i>
                                        </button>
                                    </div>
                                </div>

                            </div>
                            <div className="row">
                                <div className="col-lg-8 col-md-12">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-12">
                                            <div className="card">
                                                <div className="card-header">
                                                    <div className="d-sm-flex align-items-center">
                                                        <h5 className="card-title flex-grow-1 mb-0">{Order.file_name}</h5>
                                                    </div>
                                                </div>

                                                <div className="card-body" style={{ height: "100%", width: "100%" }}>
                                                    <center>
                                                        <div className="col-6 d-flex flex-column align-items-center mb-4">
                                                            {Order?.qrcode && (
                                                                <>
                                                                    <QRCode
                                                                        size={200}
                                                                        style={{ height: "15vh", width: "15vh" }}
                                                                        value={`${server_frontend}/orders/qr-group?trs=1&qr=${Order.qrcode}`}
                                                                        viewBox="0 0 256 256"
                                                                    />
                                                                    <h6 className="mt-3">Collective QR</h6>
                                                                </>
                                                            )}
                                                        </div>
                                                    </center>
                                                </div>

                                            </div>

                                        </div>

                                        <div className="col-lg-6 col-md-12">
                                            <div className="card">

                                                <div className="mt-3">
                                                    <div className="mt-3">
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered table-sm" style={{ lineHeight: '1.9', padding: '0.4rem' }}>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="font-weight-bold"><h6>Name:</h6></td>
                                                                        <td className="text-end">{Order.fullname}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="font-weight-bold"><h6>Order No.:</h6></td>
                                                                        <td className="text-end">{Order.ord_ID}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="font-weight-bold"><h6>Date:</h6></td>
                                                                        <td className="text-end">{vAdminformat.FormatDate(Order.date_created)}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="font-weight-bold"><h6>Components:</h6></td>
                                                                        <td className="text-end">
                                                                            {(() => {
                                                                                const totalQty =
                                                                                    Order && Array.isArray(Order.jobs) && Order.jobs.length > 0
                                                                                        ? Order.jobs.reduce((sum, job) => sum + (job.qty || 0), 0)
                                                                                        : 0; //Return 0 if there are no jobs or the list is empty
                                                                                return totalQty;
                                                                            })()}

                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="font-weight-bold"><h6>Parts:</h6></td>
                                                                        <td className="text-end">
                                                                            {(() => {
                                                                                const TotalPart = Order && Array.isArray(Order.jobs) ? Order.jobs.length : 0;
                                                                                return TotalPart;
                                                                            })()}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered table-sm" style={{ lineHeight: '1.9', padding: '0.4rem' }}>
                                                            <tbody>
                                                                {Job.map((item) => (
                                                                    <tr>
                                                                        <td className="font-weight-bold"><h6>{item.comment}</h6></td>
                                                                        <td className="font-weight-bold"><h6>{item.materials_name}</h6></td>
                                                                        <td className="font-weight-bold"><h6>X{item.qty}</h6></td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}


            {/*end row*/}
            {isComment && (
                <AddComment OrderID={Order.ord_ID} onClose={CloseAddCommentModal} getOrders={getTrackingData} />
            )}
            {isModifiyComment && (
                <ModifyComment OrderID={Order.ord_ID} onCommentID={onCommentID} onClose={CloseModifyCommentModal} getOrders={getTrackingData} />
            )}

            <div>

                {showPrintableDiv && (
                    <div ref={componentRef} id="printable-area" className="container mt-4 p-4" style={{ width: '500px', padding: '20px' }}>
                        <div className="row">
                            <div className="col-12 mt-4">
                                <div className="d-flex justify-content-center align-items-center">
                                    <div className="text-center">
                                        {Order?.qrcode && (
                                            <QRCode
                                                size={150}
                                                value={`${server_frontend}/orders/qr-group?trs=1&qr=${Order.qrcode}`}
                                            />
                                        )}
                                        <h6 style={{ fontSize: '12px', marginTop: '10px' }}>Collective QR</h6>
                                    </div>
                                </div>
                            </div>
                            {/*Table and details */}
                            <div className="col-12">
                                <div className="card">
                                    <div className="mt-3">
                                        {/*First table */}
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-sm" style={{ lineHeight: '1.9', padding: '0.4rem' }}>
                                                <tbody>
                                                    <tr>
                                                        <td className="font-weight-bold"><h6>Name:</h6></td>
                                                        <td className="text-end">{Order.fullname}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="font-weight-bold"><h6>Order No.:</h6></td>
                                                        <td className="text-end">{Order.ord_ID}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="font-weight-bold"><h6>Date:</h6></td>
                                                        <td className="text-end">{vAdminformat.FormatDate(Order.date_created)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="font-weight-bold"><h6>Components:</h6></td>
                                                        <td className="text-end">{Order.materials_name}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="font-weight-bold"><h6>Parts:</h6></td>
                                                        <td className="text-end">{Order.parts}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        {/*Second Table */}
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-sm" style={{ lineHeight: '1.9', padding: '0.4rem' }}>
                                                <tbody>
                                                    {Job.map((item, index) => (
                                                        <tr key={index}>
                                                            <td className="font-weight-bold"><h6>{item.comment}</h6></td>
                                                            <td className="font-weight-bold"><h6>{item.materials_name}</h6></td>
                                                            <td className="font-weight-bold"><h6>X{item.qty}</h6></td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/*QR code */}

                        </div>

                    </div>
                )}

            </div>
        </div>

    )
}


export default OrderQrView;